export const CustomSwitch = ({ checked, onChange, iconChecked, iconUnchecked }) => (
  <div
    onClick={onChange}
    className={`custom-switch ${checked ? "on" : "off"}`}
  >
    <div className="thumb">
      <img
        src={checked ? iconChecked : iconUnchecked}
        alt=""
        className="size_15 toggle-icon"
      />
    </div>
  </div>
);